import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownItemProps } from 'react-frontier2';
import { APIResponse } from '@arema/components/Classes';

export type DropdownValueChange = (v: any, d: DropdownItemProps)=>boolean | void;

export interface SearchDropdownProps{
	label?: string,
	placeholder?: string,
	value?: any,
	style?: React.CSSProperties,
	onValueChange?: DropdownValueChange,
}

interface SearchCoreDropdownProps<T> extends SearchDropdownProps{
	searchData?: (query: string)=>Promise<APIResponse<T[]>>,
	onShowLoad?: ()=>Promise<APIResponse<T[]>>,
	renderItem: (val: T)=>DropdownItemProps
}

function SearchCoreDropdown<T=any>(props: SearchCoreDropdownProps<T>){
	var { t } = useTranslation();
	var [showLoadError, setShowLoadError] = useState<boolean>(false);
	var [showLoad, setShowLoad] = useState<APIResponse<T[]>>(null);
	var [searchItems, setSearchItems] = useState<APIResponse<T[]>>(null);
	var [searchValue, setSearchValue] = useState<string>('');

	useEffect(()=>{
		if(props.onShowLoad){
			props.onShowLoad().then(res=>{
				if(res.error) return setShowLoadError(true);
				setShowLoad(res);
			}).catch(err=>{
				return setShowLoadError(true);
			})
		}
	}, []);

	var onSearchChange = (v: string)=>{
		setSearchValue(v);
		props.searchData(v).then(res=>{
			setSearchItems(res);
		}).catch(err=>{

		});
	}

	return <Dropdown
		style={props.style}
		loading={(props.onShowLoad && showLoad===null && !showLoadError) || (searchValue.length>=3 && searchItems===null)}
		// onSearchClear={onSearchClear}
		label={props.label}
		placeholder={props.placeholder}
		items={(searchItems?.data || showLoad?.data || []).map(props.renderItem)}
		value={props.value} 
		onValueChange={props.onValueChange}
		emptyText={showLoad && showLoad.data.length==0 ? 'No se encontraron resultados' : null}
	/>
}

export default SearchCoreDropdown;